import { render } from "./SingleSlide.vue?vue&type=template&id=1f3c4fd0&scoped=true"
import script from "./SingleSlide.vue?vue&type=script&lang=js"
export * from "./SingleSlide.vue?vue&type=script&lang=js"

import "./SingleSlide.vue?vue&type=style&index=0&id=1f3c4fd0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f3c4fd0"

export default script